import React from 'react';
import './index.scss';
const list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一'];
const countList = ['10 - 15', '15 - 30', '35 - 50', '50 - 60', '60 - 70', '70 - 80', '80 - 90', '90 - 100', '100 - 120', '140 - 160', 'x160'];
const Toast2 = props => (
  <React.Fragment>
    <div className='model_cover'></div>
    <div className='borderOut'>
      <div className='topClose'>
        <section className='title'>等级与礼包对照表</section>
        <section className='close' onClick = { () => {
          // eslint-disable-next-line react/prop-types
          props.close()
        }
        }></section>
      </div>
      <div className='main'>
        <section className='main-top-2'>
          <img src= { require('./img/textlogo.png') } />
          <div>
            <p>粉丝徽章一共<span>11个梯度等级</span>，每个梯度细分小等级，共36个小等级</p>
            <p>每个梯度的细分等级以及每日礼包的数值对照如下:</p>
          </div>
        </section>
        <section className='main-bottom-2'>
          {
            list.map((item, index) => (
              <div className='main-item' key={index}>
                <section className='main-head'>
                  <div className='gift'>
                    <img src={ require('./img/gift.png') }/>
                  </div>
                  <div className='count'>
                    { countList[index] }
                  </div>
                </section>
                <section className='main-title'>
                  <img src={ require(`./img/${index + 1}title${index == 7 ? '-2' : ''}.png`) }/>
                  <p>第{item}梯度</p>
                </section>
                <section className='main-label'>
                  <img src={ require(`./img/${index + 1}label.png`) }/>
                </section>
              </div>
            ))
          }
        </section>
      </div>
    </div>
  </React.Fragment>
)
export default Toast2;
